import moment from "moment";

export default function reports(
  initialState = {
    reports: [],
    reportsWithPagination: [],
    search: '',
    type: '',
    startDate: moment().startOf('month').toISOString(),
    endDate: moment().endOf('month').toISOString(),
    activeSort: '',
    sortOrder: '',
    totalCount: 0,
    page: 1
  },
  action
) {
  switch (action.type) {
    case 'SET_RESTAURANT_ADMIN_REPORTS':
      return {
        ...initialState,
        reports: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_REPORTS_WITH_PAGINATION':
      return {
        ...initialState,
        reportsWithPagination: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_REPORTS_SEARCH':
      return {
        ...initialState,
        search: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_REPORTS_TYPE':
      return {
        ...initialState,
        type: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_REPORTS_START_DATE':
      return {
        ...initialState,
        startDate: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_REPORTS_END_DATE':
      return {
        ...initialState,
        endDate: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_REPORTS_ACTIVE_SORT':
      return {
        ...initialState,
        activeSort: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_REPORTS_SORT_ORDER':
      return {
        ...initialState,
        sortOrder: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_REPORTS_TOTAL_COUNT':
      return {
        ...initialState,
        totalCount: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_REPORTS_PAGE':
      return {
        ...initialState,
        page: action.payload,
      };


    case 'RESTAURANT_ADMIN_REPORTS_RESET':
      return {
        ...initialState,
        reports: [],
        reportsWithPagination: [],
        search: '',
        type: '',
        startDate: moment().startOf('month').toISOString(),
        endDate: moment().endOf('month').toISOString(),
        activeSort: '',
        sortOrder: '',
        totalCount: 0,
        page: 1
      };

    default:
      return initialState;
  }
}
